<template>
    <BTable
        :class="{'cursor-pointer' : is_reduction}"
        :items="items"
        @row-clicked="onRowClicked"
        :fields="table_fields" striped show-empty >
        
        <template  v-slot:cell(min_step)="data">
            <div v-if="this.as_app">
                {{data.item.reduction.cur_cost}}
            </div>
            
            <div v-else>
                {{data.item.min_step}}
            </div>
            
        </template>
        
        
        <template #row-details="row">
            <BCard >
                <BTable
                    :items="row.item?.reduction?.items"
                    :fields="fields_reduction" striped show-empty>
                    
                    <template  v-slot:cell(user_id)="data">
                        {{data.item.contragent_info?.company}}
                    </template>
                    
                </BTable>
            </BCard>
        </template>
        
    </BTable>
</template>

<script>

import {
    BOverlay,
    BCard,
    BTable,
} from 'bootstrap-vue-next';

export default {
    name: "tender_nomenclature",
    props : {
        tender: {
            type: Object,
            required: true
        },
        
        as_app : {
            type : Boolean,
            default : false,
        }
    },
    
    
    components : {
        BTable,
        BCard
    },
    
    data() {
        return {
            items : [],
            is_load : false,
            fields_reduction : [
                { key: 'added', label: 'Дата ставки' },
                { key: 'user_id', label: 'Учасник'  },
                { key: 'cur_price', label: 'Ставка'  },
            ],
            fields : [
                { key: 'id', label: 'ID' },
                { key: 'title', label: 'Позиція'  },
                { key: 'catalog_number', label: 'Каталожний номер'  },
                { key: 'is_original', label: 'Оригінал/Аналог'  },
                { key: 'unit', label: 'Од. виміру'  },
                { key: 'quantity', label: 'Кількість'  },
            
            ],
        }
    },
    
    created() {
        this.loadPositions()
    },
    
    methods : {
        
        onRowClicked(item, index) {
            if(this.is_reduction) {
                item._showDetails = !item._showDetails
            }
        },
        
        async loadPositions() {
            this.is_load = true;
            this.items = [];
            
            await api.get('/tenders/sales/tenders/' + parseInt(this.tender.id) + "/positions").then(({data}) => {
                this.is_load = false;
                if (data.status === "operation_success") {
                    this.items = data.data;
                }
            }).catch(response => {
                this.is_load = false;
                EventBus.$emit('show_toast', {
                    err: response.data.message,
                    type: "danger",
                    title: response.data.status
                });
            })
        }
    },
    
    computed : {
        table_fields() {
            let def_fields = this.fields;
            
            if(this.is_reduction) {
                if(!this.as_app) {
                    def_fields.push({ key: 'note', label: 'Примітка'  },);
                }
                
                def_fields.push({ key: 'max_price', label: 'Максимальна ціна для 2-го туру'  });
                def_fields.push({ key: 'min_step', label: 'Крок пониження для 2-го туру'  });
            }
            else {
                if(!this.as_app) {
                    def_fields.push({key: 'note', label: 'Примітка'},);
                }
            }
            
            if(this.as_app) {
                def_fields.map(item => {
                    if(this.as_app) {
                        if(item.key == 'max_price') {
                            item.label = 'Стартова ціна';
                        }
                        if(item.key == 'min_step') {
                            item.label = 'Ціна торгів';
                        }
                    }
                    
                    return item;
                });
            }
            
            return def_fields
        },
        
        is_reduction() {
            return this.tender.tender_type === 'second_reduction';
        }
        
    }
}
</script>


<style scoped>

</style>